import initCompanyAutocompleteOnFocus from './initCompanyAutocompleteOnFocus';

const input = document.querySelector('.company-name-input input[type=text]');
const inputId = document.querySelector('.gform_body input[type=hidden]:first-of-type');

if (input && inputId) {

  input.parentNode.style.position = 'relative'

  initCompanyAutocompleteOnFocus(input, inputId);
}
